const TOKEN_KEY = 'rentpilot_token';

export const saveToken = async (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const getToken = async (): Promise<string | null> => {
  return localStorage.getItem(TOKEN_KEY);
};

export const removeToken = async () => {
  localStorage.removeItem(TOKEN_KEY);
};
